export default {
  id: 5,
  adminOnly: false,
  type: "students",
  title: "Alumnos",
  deleteEntriesAllowed: true,
  actions: {
    get: "getStudents",
    post: "postStudent",
    patch: "patchStudent",
    delete: "deleteStudent",
  },
  headers: [
    {
      title: "ID Localización",
      field: {
        name: "ID_Location",
        type: "select",
        multiple: false,
        options: "locations",
        optionName: "ID_Location",
        editable: false,
      },
    },
    {
      title: "ID Curso",
      field: {
        name: "ID_Curso",
        type: "select",
        multiple: false,
        options: "courses",
        optionName: "ID_Curso",
        editable: false,
      },
    },
    {
      title: "Actualizado",
      field: {
        name: "updatedDate",
        type: null,
      },
    },
    {
      title: "Grupo",
      field: {
        name: "grupo",
        type: "select",
        multiple: false,
        options: "groups",
        optionName: "descripcion",
        editable: true,
      },
    },
    {
      title: "ID Alumno",
      field: {
        name: "ID_Alumno",
        type: "text",
        editable: true,
      },
    },
    {
      title: "Nombre",
      field: {
        name: "nombre",
        type: "text",
        editable: true,
      },
    },
    {
      title: "Apellidos",
      field: {
        name: "apellidos",
        type: "text",
        editable: true,
      },
    },
  ],
  options: [],
  filters: [
    {
      title: "ID Localización",
      name: "ID_Location",
      type: "select",
      fromExtras: true,
      options: "locations",
      optionName: "ID_Location",
    },
    {
      title: "ID Curso",
      name: "ID_Curso",
      type: "select",
      fromExtras: true,
      options: "courses_distinct",
      optionName: "ID_Curso",
    },
    {
      title: "Grupo",
      name: "grupo",
      type: "select",
      fromExtras: true,
      options: "groups_distinct",
      optionName: "grupo",
    },
    {
      title: "ID Alumno",
      name: "ID_Alumno",
      type: "select",
      fromExtras: true,
      options: "id_distinct",
      optionName: "ID_Alumno",
      async: true,
    },
    {
      title: "Nombre",
      name: "nombre",
      type: "select",
      fromExtras: true,
      options: "name_distinct",
      optionName: "nombre",
      async: true,
    },
    {
      title: "Apellidos",
      name: "apellidos",
      type: "select",
      fromExtras: true,
      options: "lastname_distinct",
      optionName: "apellidos",
      async: true,
    },
  ],
};
